import {CPSConstants} from "commonUtils/enumerations";

export const activityStyles = {
  paddingLeftZeroPointFive: {
    pl: 0.5,
  },
  fontFamilyCSS: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
  },
  typoGraphy: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginBottom: "0.5rem",
    textAlign: "left",
    fontWeight: "500",
    fontSize: "1rem",
  },
  defaultFontFamily: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
  },
  fontWeight500: {
    fontWeight: "500",
  },
  masterContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "20px",
    "& input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#fff",
    },
    marginLeft: "0px !important",
  },
  customTooltip: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "rgba(0, 0, 0, 0.87)",
    border: "5px solid lightgray",
    fontSize: "1rem",
  },
  InfoIconStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginLeft: "0.5rem",
    cursor: "pointer",
  },
  activityFacultySearchInfoIconStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginLeft: "0.5rem",
    marginBottom: "-5px",
    cursor: "pointer",
  },
  textField: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: "#FFFFFF",
    width: "100%",
  },
  activityTextField: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: "#FFFFFF",
    width: "100%",
  },
  writeinOrField: { 
    position: "absolute",
    left: "50.6%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    px: 0.2,
    lineHeight: 1,
    zIndex: 1,
    pointerEvents: "none",
  },
  activityCustomRadioLabel: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginRight: "24px",
    "& span": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontWeight: 800,
    },
  },
  lillyLogoStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginRight: "0.5rem",
    marginTop: "0.5rem",
    width: "7rem",
    height: "4.5rem",
  },
  disabledTextField: {
    "& .MuiInputBase-root.Mui-disabled": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#f7f7f7",
    },
    "& .MuiInputBase-input.Mui-disabled": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      WebkitTextFillColor: "#003",
    },
    "& .MuiSelect-select.Mui-disabled": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#f7f7f7",
      WebkitTextFillColor: "#003",
    },
  },
  disabledTextFieldWithBold: {
    "& .MuiInputBase-root.Mui-disabled": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#f7f7f7",
      fontWeight: "bold",
    },
    "& .MuiInputBase-input.Mui-disabled": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      WebkitTextFillColor: "#003",
      fontWeight: "bold",
    },
    "& .MuiSelect-select.Mui-disabled": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#f7f7f7",
      WebkitTextFillColor: "#003",
      fontWeight: "bold",
    },
  },
  mailTextContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    wordWrap: "break-word",
    overflowWrap: "break-word",
    width: "100%",
  },
  expandSearch: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    alignItems: "center",
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: 1.5,
  },
  expandEmailTextfieldStyle: {
    color: "rgba(0, 0, 0, 0.87)",
    WebkitTextFillColor: "unset",
  },
  widthHundrendPercent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "100%",
  },
  multiSelectWidth: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "27.5rem",
  },
  multiSelectWidth20rem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "20rem",
  },
  maxWidthFiftyRem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    maxWidth: "50rem",
  },
  adminCustomRadio: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "5px",
  },
  adminCustomRadioLabel: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginRight: "24px",
    "& span": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontWeight: 800,
    },
  },
  marginLeftZero: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginLeft: "0",
  },
  commonTextarea: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "1rem",
    width: "100%",
    padding: "5px",
    borderColor: "rgba(0, 0, 0, 0.23)",
    borderRadius: "4px",
  },
  uploadFileTextfieldStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiOutlinedInput-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      "& input": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        paddingLeft: "0px",
      },
      "& fieldset": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        border: "none",
      },
    },
  },
  formLabelWordBreak: {
    display: "block",
    whiteSpace: "normal",
    wordBreak: "break-word",
    maxWidth: "100%",
    lineHeight: 1.4,
  },
  minHeight3rem: {minHeight: "3rem"},
  boxFontStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "1.4rem",
    fontWeight: "500",
    display: "flex",
    gap: "0rem",
    marginBottom: "0rem",
    marginleft: "0rem",
  },
  typoGraphyHeader: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginBottom: "0.5rem",
    textAlign: "left",
    fontWeight: "500",
    fontSize: "1.4rem",
  },
  headers: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#9cf",
    paddingRight: "5px",
  },
  dataGridStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiDataGrid-columnHeader": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#C1EA94",
      paddingLeft: "3px",
    },
    "& .MuiDataGrid-columnHeaders .MuiDataGrid-withBorderColor": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      borderRight: "1px solid #a9cb83",
    },
    "& .MuiDataGrid-columnHeader.MuiDataGrid-columnHeader--sortable.MuiDataGrid-columnHeader--sorted.MuiDataGrid-withBorderColor":
      {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        backgroundColor: "#9dd262",
        "& .MuiDataGrid-columnHeaderTitle": {
          fontFamily: CPSConstants.FONT_FAMILY as string,
          fontWeight: "bold",
        },
      },
    "& .MuiDataGrid-columnHeaderDraggableContainer": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
    },
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      display: "flex",
      padding: "2px",
    },
    "& .MuiDataGrid-columnHeaderTitleContainerContent": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: CPSConstants.FONTREMTEXT,
      fontWeight: "normal",
    },
    "& .MuiDataGrid-colCell": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      height: "auto",
    },
    "& .MuiDataGrid-row": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: CPSConstants.FONTREMTEXT,
      "& .MuiDataGrid-cell": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        borderRight: "1px solid rgba(224, 224, 224, 1)",
        padding: "5px 5px",
        lineHeight: "normal !important",
        whiteSpace: "normal !important",
        wordWrap: "break-word",
      },
    },
    "& .MuiDataGrid-footerContainer.MuiDataGrid-withBorderColor": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      "& .MuiTablePagination-selectLabel": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
      },
      "& .MuiSelect-select": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        "& .MuiPaper-root MuiPaper-elevation MuiPaper-rounded": {
          fontFamily: CPSConstants.FONT_FAMILY as string,
        },
        "& .MuiPopover-paper.MuiMenu-paper.MuiMenu-paper": {
          fontFamily: CPSConstants.FONT_FAMILY as string,
        },
      },
      "& .MuiTablePagination-displayedRows": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
      },
    },
  },
  dataGridWrapper: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    height: "auto",
    width: "100%",
    paddingTop: "1rem",
    display: "grid",
    gridTemplateColumns: "1fr",
  },
  participantDataGridWrapper: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    height: "320px",
    width: "100%",
    paddingTop: "1rem",
    display: "grid",
    gridTemplateColumns: "1fr",
  },
  searchSectionBorder: {
    border: "1px solid #9dd262",
  },
  validationAlert: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0 0 1rem 0",
  },
  gridWordBreakCell: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    whiteSpace: "normal",
    wordBreak: "break-word",
    lineHeight: 1.5,
  },
  hyperLinkStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#0000EE",
    cursor: "pointer",
  },
  paperPropAddInvoiceRequestDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "75rem",
    minHeight: "40rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },

  paperPropChangeTravelAmountDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "30rem",
    minHeight: "30rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  paperPropRelatedActivitiesDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "115rem",
    minHeight: "30rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },

  paperPropAdvisingHonorariumDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "80rem",
    minHeight: "20rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },

  paperPropViewItineraryDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "80rem",
    minHeight: "20rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },

    paperPropExpenseExceptionReasonsDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "60rem",
    minHeight: "20rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },

  paperPropsViewMeetingActivityDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "85rem",
    minHeight: "50rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },

  paperPropActivityInfoSheetDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "85rem",
    minHeight: "40rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },

  paperPropFacultiesInActivityDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "95rem",
    minHeight: "50rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },

  activitySearchContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#EFEFEF",
    padding: "5px",
  },

  activityBoxStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  activityBasicBoxContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0 0 0 5px",
  },
  datePckerPaddingIcon: {
    ".MuiOutlinedInput-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      paddingRight: "0px !important",
      width: "100%",
    },
    ".MuiOutlinedInput-root input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "0.8rem 0.4rem",
    },
    ".MuiButtonBase-root-MuiIconButton-root": {
      padding: "8px 15px 8px 0px !important",
    },
    "button.MuiButtonBase-root.MuiIconButton-root.MuiIconButton-edgeEnd.MuiIconButton-sizeMedium.css-1yq5fb3-MuiButtonBase-root-MuiIconButton-root":
      {
        marginRight: "0px !important",
        paddingLeft: "0px !important",
        paddingRight: "4px !important",
      },
  },
  advanceSearchLink: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    paddingTop: "0.5rem",
  },

  tableDesign: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& tr:nth-child(even) ": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#ffffff",
    },
    "& th": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      color: "#000",
      border: "1px solid rgb(169, 203, 131)",
      background: "#0E2079",
      fontWeight: "bold !important",
      fontSize: "1rem",
      padding: "6px 8px",
    },
    "& td": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      border: "1px solid rgb(169, 203, 131)",
      fontWeight: "bold !important",
      fontSize: "1rem",
      padding: "6px 8px",
    },
  },
  dataVerificationDetailsTable: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "90%",
    margin: "0 auto",
  },
  commonTableCell: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "none !important",
    padding: "0 0 5px 0 !important",
    fontWeight: "bold !important",
  },
  activityTextarea: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "100%",
    padding: "5px",
    borderColor: "rgba(0, 0, 0, 0.23)",
    borderRadius: "4px",
    fontSize: "1rem",
  },
  InvoiceDeleteDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "40rem",
    padding: "0 0 10px 0",
  },
  arfSaveAsDraftDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "40rem",
    padding: "0 0 10px 0",
  },
  arfDeleteAttachmentDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "60rem",
    padding: "0 0 10px 0",
  },
  boxContentFlexLeft: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "left",
    paddingTop: "1rem",
  },
  paymentRequestEmptyGrid: {
    margin: "-8px 0px 20px",
  },
  paymentRequestAttandaceUpload: {
    textDecoration: "underline",
    pl: 10,
    fontWeight: "500",
    cursor: "pointer",
  },
  borderBottomBlack: {
    borderBottom: "1px solid black",
  },
  borderBottomZero: {
    borderBottom: 0,
  },
  tableCellStandard: {
    borderBottom: 0,
    pl: 6.5,
  },
  textDecorationUnderline: {
    textDecoration: "underline",
  },
  paymentRequestDownloadFormLink: {
    display: "flex",
    justifyContent: "right",
  },
  marginRight5px: {
    marginRight: "5px",
  },
  marginLeft10px: {
    marginLeft: "-10px",
  },
  paperPropDialogWidth75remHeight35rem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "75rem",
    minHeight: "35rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },

  tableHeader: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "rgb(193, 234, 148) !important",
    "& tr": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "8px",
    },
    "& th": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      color: "#000 !important",
      border: "1px solid rgb(169, 203, 131)",
      fontWeight: "bold",
      fontSize: "1rem",
      padding: "8px",
    },
    "& td": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontWeight: "bold !important",
    },
    fontWeight: "bold",
    fontSize: "1rem",
  },
  mainTableStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    margin: "10px 0 0 0",
    width: "100%",
  },
  paddingLeft5px: {
    paddingLeft: "5px",
  },
  yesBoolean: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#0c3",
  },
  noBoolean: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "red",
  },
  paperPropUploadDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "40rem",
    minHeight: "30rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  boxPaddingUploadAlertStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingTop: "0",
  },
  paperPropDialogWidth60remHeight35rem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "60rem",
    minHeight: "35rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  marginLeftAuto: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginLeft: "auto",
  },

  fileIconStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "1.3rem",
    height: "2rem",
  },
  receiptIconStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "1.7rem",
    height: "1.7rem",
  },
  categoryIconStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "2.5rem",
    height: "2.5rem",
  },
  iconWarning: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "orange",
    width: "1.7rem",
    height: "1.7rem",
  },
  marginRightZero: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginRight: "0",
  },
  activityCustomRadio: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "5px",
  },
  widthTwentyFivePercent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "25%",
  },
  widthThirtyPercent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "30%",
  },
  widthFifteenPercent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "15%",
  },
  widthTwentyPercent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "20%",
  },
  widthFiftyPercent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "50%",
  },
  widthHundredPercent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "100%",
  },
  paperPropsViewAttachDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "100rem",
    minHeight: "45rem",
  },
  centerTheDialogContent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
  },
  iframeContent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "90rem",
    height: "40rem",
    width: "100%",
  },
  paperPropsViewImgDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "20rem",
    minHeight: "10rem",
  },
  paperPropViewItinerary: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "75rem",
    minHeight: "40rem",
  },
  paddingMarginZero: {
    padding: 0,
    margin: 0,
  },
  inputWidth7Rem: {
    border: "none !important",
    width: "7rem",
  },
  inputWidth9Rem: {
    border: "none !important",
    width: "9rem",
  },
  inputWidth11Rem: {
    border: "none !important",
    width: "11rem",
  },
  inputWidth16Rem: {
    borderBottom: "none !important",
    width: "16rem",
  },
  width7Rem: {
    width: "7rem",
  },
  width9Rem: {
    width: "9rem",
  },
  width11Rem: {
    width: "11rem",
  },
  width16Rem: {
    width: "16rem",
  },
  successIcon: {
    color: "white",
    backgroundColor: "#4CAF50",
    borderRadius: "0.25rem",
    minWidth: "1.5rem",
    minHeight: "1.5rem",
    "&:hover": {
      backgroundColor: "#45A049",
    },
  },
  dangerIcon: {
    color: "white",
    backgroundColor: "#f44336",
    borderRadius: "0.25rem",
    minWidth: "2rem",
    minHeight: "2rem",
    "&:hover": {
      backgroundColor: "#d32f2f",
    },
  },
  textAlignRight: {textAlign: "right"},
  inputTextRed: {
    "& input": {
      color: "red",
    },
  },
  width70Percent: {
    width: "70%",
  },
  inputTextAlignRight: {
    textAlign: "right",
    direction: "rtl",
    unicodeBidi: "plaintext",
  },
  customDataGridSortIconPosition: {
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      display: "block !important",
      padding: "4px 2px",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontSize: "0.95rem",
    },
  },

  addHCPProfileContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "100%",
  },
  facultyHeaders: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#9cf",
  },
  boxPaddingAlertStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingBottom: "0rem",
  },
  hideTimeIcon: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    ".MuiInputAdornment-positionEnd": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      display: "none",
    },
  },
  timePckerPaddingIcon: {
    ".MuiOutlinedInput-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "4px",
      width: "100%",
    },
    ".MuiOutlinedInput-root input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "0.4rem",
    },
  },

  parentTextarea: {
    ".textArea-auto": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      resize: "none",
    },
  },
  expenseCorrespondenceDialogContentStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingTop: "22px !important",
  },

  sendEmailCustomDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "70rem",
    minWidth: "70rem !important",
    minHeight: "50rem",
    padding: "0 0 10px 0",
  },
  cursorPointer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    cursor: "pointer",
  },
  richTextEditorHeight: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    height: "30rem !important",
  },
  paperPropsInfoSheetIconDialogDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "80rem",
    minHeight: "45rem",
  },
  viewTravelParametersDialogContentStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingTop: "22px !important",
  },
  viewTravelParametersDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "50rem",
    padding: "0 0 10px 0",
  },
  textAlignCenter: {
    textAlign: "center",
  },
  paperPropDialogWidth80remHeight50rem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "80rem",
    minHeight: "50rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  boxShadowInsetGreen: {
    boxShadow: ` inset 2px -2px 0 0 green, inset 0 -3px 0 0 green`,
  },
  calendarTemplateWrapBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#06f",
    textDecoration: "underline",
    cursor: "pointer",
  },
  calendarOnClickBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "bold",
    fontSize: "1rem",
    display: "flex",
    justifyContent: "right",
    color: "#06f",
    padding: "5px 0",
    textDecoration: "underline",
    cursor: "pointer",
  },
  activityCalendarDivider: {
    borderColor: "#a9cb83",
    padding: "2px 0",
  },
  calendarAlertPadding: {
    padding: "10px 0px",
  },
  calendarTable: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "1px solid rgb(204, 204, 204)",
    width: "27rem",
  },
  calendarTableCellOne: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#CCFFCC",
    width: "10px",
  },
  calendarTableCellTwo: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#96B8E9",
    width: "10px",
  },
  calendarTableCellThree: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#FFCCCC",
    width: "10px",
  },
  commonSmallTextTextarea: {
    ".textArea-auto": {
      fontSize: "1rem !important",
      resize: "none",
    },
  },
  notContractedReasonDialogStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "95rem",
    minHeight: "50rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },

  multiSelectFieldCustomWidth: {
    width: "15rem",
    minWidth: 0,
  },
  multiSelectFieldCustomWidth35rem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "35rem",
  },

  customFormControlLabel: {
    "& .MuiFormControlLabel-label": {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      fontWeight: "bold",
      fontFamily: CPSConstants.FONT_FAMILY as string,
    },
  },

  customFormControlLabel6px: {
    "& .MuiFormControlLabel-label": {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      fontWeight: "bold",
      fontFamily: CPSConstants.FONT_FAMILY as string,
      whiteSpace: "nowrap",
    },
  },

  verticalAlignMiddle: {
    verticalAlign: "middle",
  },

  containedButtonStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textTransform: "none",
    fontSize: "1rem",
  },

  searchIconStyle: {
    fontSize: 15,
    color: "action.active",
    marginRight: 0,
    paddingRight: 0,
  },
  textTransformNone: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textTransform: "none",
    fontSize: "1rem",
  },
  paperPropMultipleActivitiesDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "60rem",
    minHeight: "40rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  paperPropSmallDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "40rem",
    minHeight: "35rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  paperPropMediumDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "60rem",
    minHeight: "40rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  paperPropLargeDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "80rem",
    minHeight: "45rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  topicsAndTrainingDialogstyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "80rem",
    minHeight: "20rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  mapContainerStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    height: "35rem",
    marginTop: "1rem",
    borderRadius: "5px",
    marginRight: "1rem",
    marginLeft: "0.625",
  },
  cusrsorPointer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    cursor: "pointer",
  },
  paperPropResearchExamplesDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "55rem",
    height: "45rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  paperPropConsultantStatusLegendDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "75rem",
    height: "60rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  textDecorationHover: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "&:hover": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      textDecoration: "underline",
    },
  },
  paperPropInformationDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "36rem",
    height: "14rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  calendarDefaultOnClickBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "right",
    color: "#000000",
    padding: "5px 0",
    cursor: "pointer",
    fontSize: "1rem",
  },
  iconPadding: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingLeft: "0.313rem",
  },
  directionMapContainerStyle: {
    width: "100%",
    height: "500px",
  },
  paperConsultantContractInformationDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "75rem",
    height: "47rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "10px !important",
    },
  },
  paperPropApprovalStatusDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "70rem",
    height: "30rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  paperPropViewMasterGridDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "70rem",
    height: "40rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  paperPropGrandSupplierAccessDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "85rem",
    height: "50rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  tabBoxContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "15px 10px",
    width: "80rem",
  },
  tabsSelected: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "1px solid #a9cb83",
    "& .MuiTab-textColorPrimary": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      textTransform: "capitalize",
    },
    "& .Mui-selected": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      color: "#000000 !important",
      fontSize: "1rem",
      textTransform: "capitalize",
    },
  },
  tabDesign: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#233274",
    height: 7,
    borderRadius: "5px 5px 0 0",
  },
  customTabPanelBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0px 5px",
    border: "1px solid #a9cb83",
  },
  tabsCapitalize: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textTransform: "capitalize",
  },
  selectedHyperLinkStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    cursor: "pointer",
    color: "gray",
  },
  iframeSmallContent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "20rem",
    height: "40rem",
    width: "100%",
  },
  marginRightOneRem: {
    marginRight: "1rem",
  },
  marginBottomMinusFive: {
    marginBottom: "-5px",
  },
  customSmallSizeSelector: {
    p: 0,
    "& .MuiOutlinedInput-input": {
      p: 0,
      pr: 10,
      padding: "4px",
    },
    "& .MuiSelect-select.MuiSelect-outlined": {
      paddingRight: "10px",
    },
    "& .MuiSvgIcon-root": {
      right: "-1px",
    },
  },
  customHeaderIncludeInBatch: {
    fontSize: "0.95rem !important",
    overflowWrap: "anywhere",
    whiteSpace: "normal !important",
    lineHeight: "1.2 !important",
  },
  masterMedicalDiscoveryContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "1px",
    "& input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#fff",
    },
    marginLeft: "0px !important",
  },
  medicalDateDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "35rem",
    minHeight: "10rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  medicalDraftDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "55rem",
    minHeight: "10rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  medicalDraftAfterEndDateDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "35rem",
    minWidth: "35rem",
    minHeight: "10rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  activityTrainingDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "30rem",
    minHeight: "10rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  btnPlaceEvenly: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    paddingTop: "1rem",
  },
  paperPropConsultantPreferredContactInformationDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "70rem",
    minHeight: "30rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  multiSelectFieldMedicalWidth: {
    width: "16.5rem",
    minWidth: 0,
  },
  paperStateLegislationDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "85rem",
    height: "27rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  disabledTextFieldWithoutBold: {
    "& .MuiInputBase-root.Mui-disabled": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "transparent",
    },
    "& .MuiInputBase-input.Mui-disabled": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      WebkitTextFillColor: "#003",
      backgroundColor: "transparent",
    },
    "& .MuiSelect-select.Mui-disabled": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      WebkitTextFillColor: "#003",
      backgroundColor: "transparent",
    },
  },
  paperPropEditConsultantDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "40rem",
    height: "27rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  paperPropDialogAlert: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "50rem",
    minHeight: "15rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "35px !important",
    },
  },
  terminationDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "80rem",
    padding: "0 0 10px 0",
    maxWidth: "800px",
  },
  terminationPreviewDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "85rem",
    height: "40rem",
    padding: "0 0 10px 0",
    maxWidth: "720px",
  },
  medicalActivityPreviewDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "62rem",
    minHeight: "45rem",
  },
  terminationPreviewiframeContent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "60rem",
    height: "45rem",
  },
  cancellationDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "50rem",
    padding: "0 0 10px 0",
    maxWidth: "800px",
  },
  paperPropReasonDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "50rem",
    minHeight: "15rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  advisingContractWarningDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "52rem",
    minHeight: "15rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  matchMultipleActivitiesDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "90rem",
    minHeight: "32rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  paperPropsPreviewFileDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "80rem",
    minHeight: "52rem",
  },
  hcpRegistrationAdminScrollNone: {
    "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
      display: "none",
    },
  },
  paymentFieldStyles: {
    width: "20rem",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  consultantTable: {
    tableLayout: "fixed",
    width: "100%",

    ".fee-for-service-cell": {
      width: "15%",
    },
    ".quantity-cell": {
      width: "15%",
    },
    ".amount-cell": {
      width: "15%",
    },
    ".payment-cell": {
      textOverflow: "ellipsis",
      overflow: "hidden",
      width: "20%",
    },
    ".subtotal-fee-for-service-cell": {
      width: "16%",
    },
    ".action-cell": {
      width: "8%",
    },
  },
  listItemDiscStyles: {listStyleType: "disc", pl: 1},
  displayListItem: {
    display: "list-item",
  },
  paperPropActivityQRCodeDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "58rem",
    minHeight: "40rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  textDecorationHoverBlue: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "&:hover": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      color: "#0000EE",
      textDecoration: "underline",
    },
  },
  paddingTopZero: {
    paddingTop: "0px",
  },
  consultantContractionInformationTotalFeeOfSericeTotalExpense: {
    display: "grid",
    gridTemplateColumns: "max-content 20px 260px",
    columnGap: 1,
    rowGap: 1,
    alignItems: "center",
    "& > .label": {
      justifySelf: "end",
      whiteSpace: "nowrap",
    },
    "& > .dollar": {
      textAlign: "center",
      fontWeight: 500,
    },
  },
  uploadReceiptZoomContainer: {
    width: 390,
    height: 500,
    border: "1px solid #ccc",
    overflowX: "auto",
    overflowY: "auto",
    background: "#fafafa",
    display: "flex",
    justifyContent: "center",
  },
  opacityPointFour: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    opacity: 0.4,
  },
  marginLeftOne: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginLeft: "1rem",
  },
  paperPropSignatureLargeDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "95rem",
    minHeight: "45rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  RSVPStyle: {
    width: "40px",
    height: "26px",
  },
  rsvpPopperStyle: {
    position: "relative",
    width: "400px",
    height: "380px",
  },
  rsvpPopperHeaderStyle: {
    backgroundColor: "#233274",
    color: "#fff",
    height: "30px",
  },
  rsvpPopperArrowIconStyle: {
    position: "absolute",
    width: 10,
    height: 10,
    bgcolor: "background.paper",
    right: -5,
    top: "50% !important",
    transform: "translateY(-50%) rotate(45deg) !important",
    zIndex: 1,
  },
  multiLineHeaderText: {
    lineHeight: 1.4,
    fontWeight: 500,
  },
  multiLineCellText: {
    lineHeight: 1.4,
  },
  noteIconStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "1rem",
    height: "1.5rem",
    marginTop: "-0.3rem",
  },
  columnRenderHeaderStyles: {
    display: "flex",
    flexDirection: "column",
    whiteSpace: "normal", // ✅ allow wrapping
    wordBreak: "break-word", // ✅ break long words if needed
    lineHeight: 1.2,
  },
  ousFileInputStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiOutlinedInput-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      "& input": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        padding: "7px 0px !important",
      },
      "& fieldset": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        border: "none",
      },
    },
  },
};
